import React from "react"
import BottomBar from "../BottomBar/bottombar"
import { useHistory } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { apiEndPoints } from "constants/apiEndpoints"
import { useState, useEffect } from "react"
import { Modal } from "@fourkites/elemental-modal"
import { InfoAlert } from "../../images"
import { http } from "utils/http"
import { apiData } from "components/EventTracking/EventTracking"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import "../EventTracking/EventTracking.css"
import { useTranslation } from "react-i18next"

function BreakTracking() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [eventData, setEventData]: any = useState()
  const [radioBtnVal, setRadioBtnVal] = useState("")
  const [inpVal1, setInpVal1] = useState("")
  const [inpVal2, setInpVal2] = useState("")
  const [isSelected, setIsSelected] = useState(false)
  const [disabledProceedET, setDisabledProceedET] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [isReadonly, setIsReadonly] = useState(true)
  const [addClass, setAddclass] = useState("label-text-hrs")
  const [isSubmitted, setIsSubmitted] = useState(false)
  const loadDetailsCode = useSelector(
    (state: RootState) => state.loadDetailsReducer.loadDetails?.code
  )

  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const facilityId = useSelector(
    (state: RootState) => state.facilityReducer.facility?.id || ""
  )
  const rgx = /^[0-9]{0,2}$/
  let errEle = document.getElementById("error") as HTMLElement
  const errInfo = {
    splCharacter: t("no_special_characters_allowed"),
    valComparer: t("value_should_greater_than", { value: inpVal1 }),
    lessHoursValue: t("value_should_be_greater_than_0"),
    lessMinsValue: t("value_should_be_between_0_and_59_mins")
  }
  const setBreakTrack = () => {
    setIsSubmitted(true)
    if (parseInt(inpVal2) > 59) {
      errEle.innerHTML = errInfo.lessMinsValue
      setDisabledProceedET(true)
      return
    }
    if (parseInt(inpVal1) == 0 && parseInt(inpVal2) == 0) {
      errEle.innerHTML = errInfo.lessHoursValue
      setDisabledProceedET(true)
      return
    }

    let asset = {
      ...assetReducer.asset,
      HOS: radioBtnVal
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    if (parseInt(inpVal1) >= 4) {
      setIsOpen(true)
      return
    }

    if (loadDetailsCode !== 200) {
      http
        .put(
          `${apiEndPoints.submitassetsinfo}/${assetReducer.asset?.id}`,
          {
            estimatedCheckout: assetReducer.asset?.estimatedCheckout,
            hos: radioBtnVal,
            company: {
              usdot: assetReducer.asset?.usdot,
              name: assetReducer.asset?.companyName
            }
          },
          {}
        )
        .then(res => {
          history.push("/success-asset")
        })
        .catch(err => {
          history.push("/success-asset")
        })
    } else {
      history.push("/asset-summary")
    }
  }

  useEffect(() => {
    setEventData(apiData)
  }, [])

  useEffect(() => {
    if (inpVal1 !== "" || inpVal2 !== "") {
      setDisabledProceedET(false)
      setIsSubmitted(false)
      let customValue1
      let customValue2
      if (inpVal1) {
        customValue1 =
          parseInt(inpVal1) < 10 ? "0" + parseInt(inpVal1) : inpVal1
      }
      if (inpVal2) {
        customValue2 =
          parseInt(inpVal2) < 10 ? "0" + parseInt(inpVal2) : inpVal2
      }
      if (customValue1 === undefined) {
        customValue1 = "00"
      }
      if (customValue2 === undefined) {
        customValue2 = "00"
      }
      let customValue = customValue1 + " hrs " + customValue2 + " mins"
      setRadioBtnVal(customValue)
    } else if (inpVal1 == "" && inpVal2 == "") {
      setIsSubmitted(false)
      setDisabledProceedET(true)
    }
    if (isSelected) {
      setDisabledProceedET(false)
    }
  }, [radioBtnVal, inpVal1, inpVal2])

  const changeHandler1 = (e: any) => {
    errEle.innerHTML = ""
    let val = e
    if (!rgx.test(val)) {
      return
    }

    setInpVal1(val)
  }

  const changeHandler2 = (e: any) => {
    errEle.innerHTML = ""
    let val = e
    if (!rgx.test(val)) {
      return
    }

    setInpVal2(val)
  }

  const onRadioBtnChange = (e: any) => {
    let radioBtnsVal
    if (
      e.target.checked &&
      e.target.defaultValue !== "Other (Please specify):"
    ) {
      radioBtnsVal = e.target.value
      if (errEle) {
        errEle.innerHTML = ""
      }
      setIsSelected(true)
      setIsReadonly(true)
      setInpVal1("")
      setInpVal2("")
      setAddclass("label-text-hrs")
    } else {
      setIsSelected(false)
      setIsReadonly(false)
      setAddclass("")
    }
    setRadioBtnVal(radioBtnsVal)
  }

  const onDlgClose = () => {
    setIsOpen(false)
  }

  const onModalConfirm = () => {
    if (localStorage.getItem("previousPath") === "carrier-info") {
      http
        .put(
          `${apiEndPoints.submitassetsinfo}/${assetReducer.asset?.id}`,
          {
            estimatedCheckout: assetReducer.asset?.estimatedCheckout,
            hos: radioBtnVal,
            company: {
              usdot: assetReducer.asset?.usdot,
              name: assetReducer.asset?.companyName
            }
          },
          {}
        )
        .then(res => {
          history.push("/success-asset")
        })
        .catch(err => {
          history.push("/success-asset")
        })
    } else {
      history.push("/asset-summary")
    }
  }

  return (
    <>
      <div className="radio-group-container">
        {eventData && (
          <div className="radio-group-header">
            {t(eventData?.data?.gatelink[1].title)}
          </div>
        )}
        <div className="radio-group-wrapper">
          <form className="mainForm">
            <div className="radio-group">
              {eventData?.data?.gatelink[1]?.options.map(
                (options: any, index: any) => {
                  return (
                    <label key={index}>
                      <input
                        type="radio"
                        name="TimeTracking"
                        value={options.name}
                        onChange={e => onRadioBtnChange(e)}
                      />
                      {t(options.name)}
                    </label>
                  )
                }
              )}
            </div>
            {eventData && (
              <div className="number-input">
                <label>{t("in")}</label>&nbsp;
                <input
                  className={
                    parseInt(inpVal1) == 0 && isSubmitted ? "hr-input" : ""
                  }
                  type="tel"
                  placeholder="HH"
                  maxLength={2}
                  value={inpVal1}
                  readOnly={isReadonly}
                  onChange={e => {
                    changeHandler1(e.target.value)
                  }}
                />
                &nbsp;&nbsp;
                <label className={`${addClass}`}>Hrs</label>&nbsp;&nbsp;
                <label>{t("and")}</label>&nbsp;&nbsp;
                <input
                  className={
                    parseInt(inpVal2) > 59 && isSubmitted ? "hr-input" : ""
                  }
                  type="tel"
                  placeholder="MM"
                  maxLength={2}
                  value={inpVal2}
                  readOnly={isReadonly}
                  onChange={e => {
                    changeHandler2(e.target.value)
                  }}
                />
                &nbsp;&nbsp;
                <label className={`${addClass}`}>{t("mins")}</label>
                <p id="error"></p>
              </div>
            )}
          </form>
        </div>
        <Modal
          title=""
          customHeader={
            <div className="header-container">
              <span>
                <b>{t("alert")}</b>
              </span>
              <span className="close-icon" onClick={() => onDlgClose()}>
                X
              </span>
            </div>
          }
          show={isOpen}
          size="large"
          onSave={() => onModalConfirm()}
          saveLabel={t("i_confirm")}
        >
          <div className="modal-container">
            <img className="warning-img-ET" src={InfoAlert} alt="info" />
            <div>
              <p>{t("checking_out_text")}</p>
              <p className="time-text">
                <b>
                  {t("in_value_hours", {
                    val1: inpVal1,
                    val2: inpVal2
                  })}
                </b>
              </p>
              <p>{t("confirm_text")}</p>
            </div>
          </div>
        </Modal>
      </div>
      <BottomBar
        disabled={disabledProceedET}
        onClick={() => setBreakTrack()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default BreakTracking
